import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const measurementSet = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    createdOn: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('When the set was created.'),

    referenceLength: z
      .number()
      .nullable()
      .optional()
      .displayName('Reference length (in)')
      .describe(
        "Real-world length in inches of this set's scaling reference line. Seeded\nfrom the reference measurement type when the set is created and editable\nper set, so an unshod front pastern (6 in) and a shod one (6.25 in) scale\ncorrectly on the same catalog.",
      ),

    scaleFactor: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe(
        'Inches per pixel, derived from the scaling-reference measurements.',
      ),

    salePhotoId: z.number().hidden().describe('Foreign key to SalePhoto'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    salePhoto: belongsTo('SalePhoto'),

    createdBy: references('User'),

    measurements: hasMany('Measurement'),
  })
  .describe(
    'One measuring occasion on a sale photo. Records the line measurements drawn\nin that pass and carries the scale factor derived from its reference lines,\nso a photo can be measured more than once.',
  )
  .as('MeasurementSet');

export { measurementSet as measurementSetSchema };
